/* eslint-disable import/no-cycle */
/* eslint-disable no-shadow */
import {
  GetterTree, MutationTree, ActionTree, Module
} from 'vuex';
import IVehicle from '@/models/vehicle/interfaces/vehicle.d';
import VehicleModuleOptions from '@/models/VehicleModuleOptions';
import VehicleStatusType from '@/enums/VehicleStatusType';
import IRootState from '../states/interfaces/index.d';
import IVehicleManagementState from '../states/interfaces/vehicle-management-state.d';
import VehicleManagementState from '../states/vehicle-management-state';

export const state: IVehicleManagementState = new VehicleManagementState();

export const getters: GetterTree<IVehicleManagementState, IRootState> = {
  moduleKeys: (state): string[] => state.moduleKeys,
  extraVehicles: (state): IVehicle[] => state.extraVehicles,
  vehicles: (state, getters, rootState, rootGetters): IVehicle[] => {
    const enquiryVehicles: IVehicle[] = [
      rootGetters['vehicleModule/currentVehicle'],
      ...state.extraVehicles];

    state.moduleKeys.forEach((moduleKey: string) => {
      const vehicle : IVehicle | null = rootGetters[`vehicleModule${moduleKey}/currentVehicle`];
      if (vehicle !== null && vehicle.vehicleStatusType !== VehicleStatusType.PartExchange) {
        enquiryVehicles.push(vehicle);
      }
    });

    return enquiryVehicles;
  }
};

export const mutations: MutationTree<IVehicleManagementState> = {
  addModuleKey: (state: IVehicleManagementState, moduleKey: string) => {
    state.moduleKeys.push(moduleKey);
  },
  removeModuleKey: (state: IVehicleManagementState, moduleKey: string) => {
    state.moduleKeys = state.moduleKeys.filter((x) => x !== moduleKey);
  },
  addExtraVehicle: (state: IVehicleManagementState, vehicle: IVehicle) => {
    state.extraVehicles.push(vehicle);
  },
  removeExtraVehicle: (state: IVehicleManagementState, vehicle: IVehicle) => {
    state.extraVehicles = state.extraVehicles
      .filter((x) => x.vehicleStatusType === vehicle.vehicleStatusType
        && x.vehicleType === vehicle.vehicleType
        && x.rangeId !== vehicle.rangeId);
  },
  resetExtraVehicles: (state: IVehicleManagementState) => {
    state.extraVehicles.splice(0, state.extraVehicles.length);
  }
};

export const actions: ActionTree<IVehicleManagementState, IRootState> = {
  submitCreateNewModuleInstances({ commit, dispatch }, options: VehicleModuleOptions): Promise<string> {
    options.moduleKey = `${state.moduleKeys.length + 1}`;

    dispatch('vehicleModule/createNewModuleInstance', options, { root: true });
    dispatch('searchQueryModule/createNewModuleInstance', options, { root: true });
    dispatch('vehicleSearchModule/createNewModuleInstance', options, { root: true });
    commit('addModuleKey', options.moduleKey);

    return new Promise((resolve) => {
      resolve(options.moduleKey);
    });
  },
  submitRemoveModuleInstances({ commit }, moduleKey) {
    this.unregisterModule(`vehicleModule${moduleKey}`);
    this.unregisterModule(`vehicleSearchModule${moduleKey}`);
    this.unregisterModule(`searchQueryModule${moduleKey}`);

    commit('removeModuleKey', moduleKey);
  },
  submitResetModuleInstances({ dispatch, state }) {
    state.moduleKeys.forEach((moduleKey) => {
      dispatch('submitRemoveModuleInstances', moduleKey);
    });
  },
  submitAddExtraVehicle({ commit }, vehicle: IVehicle) {
    commit('addExtraVehicle', vehicle);
  },
  submitRemoveExtraVehicle({ commit }, vehicle: IVehicle) {
    commit('removeExtraVehicle', vehicle);
  },
  submitResetExtraVehicles({ commit }) {
    commit('resetExtraVehicles');
  }
};

export const vehicleManagementModule: Module<IVehicleManagementState, IRootState> = {
  state, getters, mutations, actions, namespaced: true
};
